import { Workbox } from "workbox-window";

const wb = new Workbox("/sw.js");

export default {
    name: "useRegisterSW",
    data() {
        return {
            updateSW: undefined,
            offlineReady: false,
            updateFound: false,
            needRefresh: false,
            registered: false,
            registration: null
        };
    },
    async mounted() {
        try {
            const { registerSW } = await import("virtual:pwa-register");
            const vm = this;
            this.updateSW = registerSW({
                immediate: true,
                onOfflineReady() {
                    vm.offlineReady = true;
                    vm.onOfflineReadyFn();
                },
                onNeedRefresh() {
                    vm.needRefresh = true;
                    vm.onNeedRefreshFn();
                },
                onRegistered(swRegistration) {
                    vm.registered = true;
                    vm.registration = swRegistration;
                    console.log("Registration succeeded. Scope is", swRegistration.scope);
                    swRegistration && vm.handleSWManualUpdates(swRegistration);
                },
                onRegisterError(e) {
                    console.error("Service Worker registration failed with", e);
                    vm.handleSWRegisterError(e);
                }
            });
        }
        catch {
            console.log("PWA disabled.");
        }
  
    },
    methods: {
        async closePromptUpdateSW() {
            this.offlineReady = false;
            this.needRefresh = false;
        },
        onOfflineReadyFn() {
            console.log("onOfflineReady");
        },
        onNeedRefreshFn() {
            console.log("onNeedRefresh");
        },
        updateServiceWorker() {
            console.log("updateServiceWorker");
            this.updateSW && this.updateSW(true);
        },
        async checkForSWUpdate() {
            console.log("checkForUpdate");
            if(this.registration){
                await this.registration.update();

                return new Promise((resolve, reject) => {
                    const timeout = setTimeout(() => {
                        //wb.removeEventListener("waiting", updateListener);
                        this.needRefresh = false;
                        resolve(false);
                    }, 2000);

                    const updateListener = () => {
                        clearTimeout(timeout);
                        console.log("Update found!");
                        wb.addEventListener("waiting", () => {
                            this.needRefresh = true;
                            resolve(true);
                        });
                    };

                    this.registration.addEventListener("updatefound", updateListener);                    
                });
                //const newSWExists = reg.installing != null;
                //if(newSWExists) {
                //    const ready = await navigator.serviceWorker.ready;
                //    if(ready){
                //        return true;
                //    }
                //} else {
                //    return false;
                //}
            } else {
                return false;
            }
        },
        handleSWManualUpdates(swRegistration) {},
        handleSWRegisterError(error) {}
    }
};